import React from "react";

import { LibraryView } from "common/constants";
import { LibraryPaneLayout } from "js/editor/PresentationLibrary/LibraryPaneLayout";
import { StarterTemplatesPane } from "js/editor/PresentationLibrary/StarterTemplatesPane";
import { LibraryTemplatesLayoutProps, TemplateCreationClickShield } from "js/editor/PresentationLibrary/libraryTemplatesPaneShared";

export default function LibraryStarterTemplatesPaneLayout({
    sideBarWidth,
    onResizeSidebar,
    showNavigationSidebar = true,
    onCreate,
    isCreatingPresentation,
}: LibraryTemplatesLayoutProps) {
    return (
        <LibraryPaneLayout
            libraryView={LibraryView.TEMPLATES}
            onResizeSidebar={onResizeSidebar}
            showNavigationSidebar={showNavigationSidebar}
            sideBarWidth={sideBarWidth}
        >
            <TemplateCreationClickShield visible={isCreatingPresentation} />
            <StarterTemplatesPane onCreate={onCreate} />
        </LibraryPaneLayout>
    );
}
